var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/sms"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 22H7C4 22 2 20.2353 2 16.1176V7.88235C2 3.76471 4 2 7 2H15.3431C16.404 2 17.43 2.41395 18.1658 3.17812C19.037 4.08282 19.5647 4.73549 21.1633 6.80022C21.7052 7.50013 22 8.36256 22 9.24774V16.1176C22 20.2353 20 22 17 22Z",
    stroke: "#4D7C79",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M7.5 22V18C7.5 16.8954 8.39543 16 9.5 16H16C17.1046 16 18 16.8954 18 18V22",
    stroke: "#4D7C79",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M16.5 8.25C16.9142 8.25 17.25 7.91421 17.25 7.5C17.25 7.08579 16.9142 6.75 16.5 6.75V8.25ZM6.75 2V5.5H8.25V2H6.75ZM9.5 8.25H16.5V6.75H9.5V8.25ZM6.75 5.5C6.75 7.01878 7.98122 8.25 9.5 8.25V6.75C8.80964 6.75 8.25 6.19036 8.25 5.5H6.75Z",
    fill: "#4D7C79"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.4dc267869b39d7333365bc15c47eaa82.svg";
export { ForwardRef as ReactComponent };